export default __webpack_public_path__ + "static/media/manDriving.5a6bc200.svg";